import * as React from 'react';
import { IMicrositeRecipientForList } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IMicrositeRecipientForList,
    onConfirm: () => void,
    onCancel: () => void
}

const ResendApprovalEmail: React.FunctionComponent<IProps> = (props) => {
    if (props.data == null) {
        return null;
    }

    return (
        <Modal animation={true} backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Resend Approval Email Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='text-center' style={{ marginBottom: 10 }}>Please confirm that you would like to resend the approval email to the following patient:</div>
                <div className='text-center'>{props.data.fullName}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirmed</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ResendApprovalEmail;